export const BlurOverlay = ({ show }: { show?: boolean }) => {
  return (
    <div
      style={{
        height: 'calc(100% + 4px)',
        width: 'calc(100% + 4px)',
        left: '-4px',
        top: '-4px',
        position: 'absolute',
        background: 'rgba(var(--gray-2), 0.1)',
        pointerEvents: show ? 'auto' : 'none',
        userSelect: 'none',
        cursor: 'default',
        transition: 'opacity 0.2s',
        opacity: show ? 1 : 0,
        backdropFilter: 'blur(3px)',
        zIndex: 1,
      }}
    />
  );
};
